<template>
    <div class="flex items-center gap-3 p-4 justify-end">
        <select v-model="filterType" class="border border-gray-300 p-2 rounded-md w-200" @change="emitFilter">
            <option value="last_days">{{ $t('last-days') }}</option>
            <option value="period">{{ $t('period') }}</option>
        </select>

        <template v-if="filterType === 'last_days'">
            <input type="number" v-model.number="lastDays" class="border border-gray-300 p-2 rounded-md w-20 text-end"
                @change="emitFilter" min="1" />
            <label class="text-gray-700 font-medium">{{ $t('days') }}</label>
        </template>

        <template v-else>
            <label class="text-gray-700 font-medium">{{ $t('start') }}:</label>
            <input type="date" v-model="startDate" class="border border-gray-300 p-2 rounded-md" @change="emitFilter"
                :max="endDate || today" />
            <label class="text-gray-700 font-medium">{{ $t('end') }}:</label>
            <input type="date" v-model="endDate" class="border border-gray-300 p-2 rounded-md" @change="emitFilter"
                :min="startDate" :max="today" />
        </template>
    </div>
</template>

<script>
export default {
    name: "DateFilterMenu",
    data() {
        return {
            filterType: "last_days",
            lastDays: 7,
            startDate: null,
            endDate: null,
            today: new Date().toISOString().split('T')[0]
        };
    },
    methods: {
        emitFilter() {
            if (this.filterType === "last_days") {
                this.$emit("filter-change", {
                    type: "last_days",
                    days: this.lastDays
                });

                return;
            }

            if (!this.startDate || !this.endDate) {
                return;
            }

            this.$emit("filter-change", {
                type: "period",
                start: this.startDate,
                end: this.endDate
            });
        }
    }
};
</script>
